module.exports = __webpack_public_path__ + "img/magento-support-security.677490f2.webp";